import { render } from "./casePage.vue?vue&type=template&id=707f03aa&scoped=true"
import script from "./casePage.vue?vue&type=script&lang=js"
export * from "./casePage.vue?vue&type=script&lang=js"

import "./casePage.vue?vue&type=style&index=0&id=707f03aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707f03aa"]])

export default __exports__